import type { ReactElement } from 'react'

import { useAnalytics } from '@/analytics/hooks/useAnalytics'
import { AnalyticsEvent } from '@/analytics/schema/events.schema'
import { ArrowUpRight } from '@/assets/icons'
import { Button } from '@/components/button/Button'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/popover/Popover'

interface CollaborationOrgPromptPopoverProps {
  children: ReactElement
  onCreateOrganization: () => void
}

export function CollaborationOrgPromptPopover({ children, onCreateOrganization }: CollaborationOrgPromptPopoverProps) {
  const { trackEvent } = useAnalytics()

  return (
    <Popover>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverContent side="bottom" align="end" width="md">
        <div className="flex flex-col gap-2">
          <div className="flex flex-col gap-1">
            <p className="text-sm font-semibold leading-5 tracking-[-0.15px] text-brand-neutral-950">Collaborate on this matter</p>
            <p className="text-sm leading-5 tracking-[-0.15px] text-brand-neutral-950">
              Invite colleagues to work on this matter with their own Paxton account.
            </p>
          </div>
          <div className="-mx-2">
            <Button
              variant="plain"
              color="primary"
              size="sm"
              trailingIcon={<ArrowUpRight className="h-3.5 w-3.5" />}
              onClick={() => {
                trackEvent(AnalyticsEvent.OrganizationCreationCtaClicked)
                onCreateOrganization()
              }}
            >
              Create an organization
            </Button>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  )
}
